import { memo } from "react"
import { SidebarLinks } from "@components"
import PropTypes from "prop-types"

const DesktopSidebar = ({ className = "" }) => (
  <div className={`${className} min-h-screen xl:inset-y-0 xl:z-30 xl:w-80 xl:block h-full`}>
    <div className="flex flex-col px-6 py-12 pb-4 -mb-4 overflow-y-auto grow gap-y-5 bg-sidebar">
      <SidebarLinks />
    </div>
  </div>
)

DesktopSidebar.propTypes = {
  className: PropTypes.string,
}

export default memo(DesktopSidebar)
